<template>
  <button class="d-flex align-items-center cursor-pointer all-radius btn-common btn" :class="['btn-' + type, size]" :disabled="load">
    <span class="d-flex b-radius-100px position-relative bg-rgba" :class="load ? 'load-animation' : ''">
      <span class="load position-absolute">
        <svg-icon :class="svgColor" name="ri-loader-5-line" :size="sizeNum"></svg-icon>
      </span>
      <span class="default position-absolute">
        <svg-icon :class="svgColor" :name="icon ? icon: 'ri-arrow-up-s-line'" :size="sizeNum"></svg-icon>
      </span>
      <span class="check">
        <svg-icon :class="svgColor" name="ri-check-line" :size="sizeNum"></svg-icon>
      </span>
    </span>
    <span class="mx-10 w-100 text-center">{{!load ? title : '处理中...'}}</span>
  </button>
</template>

<script>
export default {
  name: 'EleButton',
  components: {
  },
  props: {
    title: String,
    type: String, // primary / success / warning / danger / info / white
    size: String, // medium / small / mini
    icon: String,
    load: Boolean
  },
  data () {
    return {
      // svg大小 和 颜色
      sizeNum: 0,
      svgColor: ''
    }
  },
  // =*=生命函数钩子=*=
  // created 是在模版渲染成html或者模版编译进路由前调用
  // mounted 是在模版已经渲染成html之后调用
  // =*=[keep-alive]=*=
  // activated, deactivated 这两个生命周期函数一定是要在使用了keep-alive组件后才会有的，否则则不存在
  // 页面第一次进入，钩子的触发顺序created -> mounted -> activated
  // 退出时触发deactivated。当再次进入（前进或者后退）时，只触发activated
  // activated 中的逻辑不管是否需要缓存都会进行执行
  created () {
    // 判断按钮大小
    switch (this.size) {
      case 'medium':
        this.sizeNum = 24;
        break
      case 'small':
        this.sizeNum = 21;
        break
      default:
        this.sizeNum = 18;
    }
    // 判断颜色
    switch (this.type) {
      case 'white':
        this.svgColor = 'text-color-black-80';
        break
      default:
        this.svgColor = 'text-color-black-10';
    }
  },
  mounted () {
  },
  activated () {
  },
  // watch 专门负责监听的模块 某些地方有用
  watch: {
  },
  // methods 所有的方法都应该在这个函数里定义，其他地方调用
  methods: {
  },
  // computed 是计算属性 有需要计算的值放这里
  computed: {
  }
}
</script>

<style scoped>
/* 大小 */
.medium{padding: 11px 14px;}
.medium span.mx-10{font-size: 14px; line-height: 14px;}
.medium span svg{padding: 2px;}
.medium .default, .medium .check{ width: 24px; height: 24px;}
.small{padding: 9px 11px;}
.small span.mx-10{font-size: 12px; line-height: 12px;}
.small span svg{padding: 2px;}
.small .default, .small .check{ width: 21px; height: 21px;}
.mini{padding: 7px 8px;}
.mini span.mx-10{font-size: 12px; line-height: 12px;}
.mini span svg{padding: 3px;}
.mini .default, .mini .check{ width: 18px; height: 18px;}

/*颜色*/
/*.primary{background: #0067f8;}*/
/*.primary:hover{box-shadow: 0 8px 25px -8px #0B6CF5; background: #1E78FA;}*/
/*.success{background: #3bc475;}*/
/*.success:hover{box-shadow: 0 8px 25px -8px #28C76F; background: #48CF85;}*/
/*.warning{background: #fd9e52;}*/
/*.warning:hover{box-shadow: 0 8px 25px -8px #FFAD5F; background: #FF9F43;}*/
/*.danger{background: #e7565a;}*/
/*.danger:hover{box-shadow: 0 8px 25px -8px #C74748; background: #EA5455;}*/
/*.info{background: #3b426b;}*/
/*.info:hover{box-shadow: 0 8px 25px -8px #414678; background: #444E82;}*/
/*.white{background: #fff; color: #333 !important; border:1px solid #e9edf6 !important;}*/
/*.white:hover{box-shadow: 0 8px 25px -8px #969cb8; background: #fff; border:1px solid #fff !important;}*/
/*.white .bg-rgba{background: rgba(0,0,0,0.05);}*/

/*禁选*/
/*button[disabled]{opacity: 0.7; cursor:not-allowed}*/
/*button[disabled]:hover{box-shadow: none}*/

/*默认*/
.bg-rgba{background: rgba(0,0,0,0.4);}
.load{ width: 100%; height: 100%;}
.b-radius-100px{border-radius:100px}
.btn-common{transition: .4s;}
.btn-common:hover{transform: translateY(-.15rem); transition: .4s}
.check, .load{transform: scale(0); transition: 0.3s}
.default{transition: 0.3s}
.btn-common:hover .check{transform: scale(0.9)}
.btn-common:hover .default{transform: scale(0)}
.load-animation{animation: loading-rotate 1s linear infinite;}
.load-animation .load{transform: scale(1)}
.load-animation .load svg{padding: 0;}
.load-animation .check, .load-animation .default{transform: scale(0) !important;}
</style>



// WEBPACK FOOTER //
// src/components2/theme/basics/layout/ZdyButton.vue